import React, { useEffect } from 'react';

const VTURB_ACCOUNT_ID = '25f8f442-d0db-4c6b-821d-d030739ac9eb';

interface VturbPlayerProps {
  playerId: string;
}

const VturbPlayer: React.FC<VturbPlayerProps> = ({ playerId }) => {
  useEffect(() => {
    const playerSrc = `https://scripts.converteai.net/${VTURB_ACCOUNT_ID}/players/${playerId}/v4/player.js`;
    const added: HTMLElement[] = [];

    // Preload só nesta página (não vai para o index.html global)
    const preload = (href: string, as: string) => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.href = href;
      link.as = as;
      document.head.appendChild(link);
      added.push(link);
    };
    preload(playerSrc, 'script');
    preload('https://scripts.converteai.net/lib/js/smartplayer-wc/v4/smartplayer.js', 'script');

    // Carrega o player uma única vez
    if (!document.querySelector(`script[data-vturb-player="${playerId}"]`)) {
      const script = document.createElement('script');
      script.src = playerSrc;
      script.async = true;
      script.dataset.vturbPlayer = playerId;
      document.head.appendChild(script);
      added.push(script);
    }

    return () => {
      added.forEach((el) => el.remove());
    };
  }, [playerId]);

  return (
    <div className="relative w-full overflow-hidden rounded-2xl shadow-2xl border-4 border-white ring-1 ring-purple-100 bg-black">
      {React.createElement(
        'vturb-smartplayer',
        {
          id: `vid-${playerId}`,
          style: { display: 'block', margin: '0 auto', width: '100%' },
        },
        <div
          className="vturb-player-placeholder"
          style={{
            position: 'relative',
            width: '100%',
            padding: '56.25% 0 0',
            zIndex: 0,
            backgroundColor: 'black',
          }}
        />
      )}
    </div>
  );
};

export default VturbPlayer;
